import React from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import AbsoluteDiv from '@bsd/dashboard-toolkit/components/AbsoluteDiv'

import { createGeoCategory } from '../actions/geoCategories'
import GeoCategoryForm from './GeoCategoryForm'


class NewCategory extends React.Component {

  handleCreateCategory = async (data) => {
    const category = await this.props.onCategorySave({
      ...data,
      sectionId: this.props.selectedSectionId,
    })
    this.props.history.push(`/${category.id}`)
  }

  render() {
    return (
      <AbsoluteDiv>
        <h3>Добавление категории</h3>
        <GeoCategoryForm onSubmit={this.handleCreateCategory}/>
      </AbsoluteDiv>
    )
  }

}

function mapStateToProps(state) {
  return {
    selectedSectionId: state.dashboard.selectedSectionId,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onCategorySave: (data) => dispatch(createGeoCategory(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewCategory))